<template>
	<div>
		<!-- <code>{{attributes}}</code> -->
		<!-- <code>{{selectedAttributes}}</code> -->
		<v-list class="decision-tree pa-0">
			<v-list-group
				v-for="(attribute, index) in filteredAttributes"
				:key="attribute.slug"
				:value="currentAttribute === index"
				@click="currentAttribute = index"
				v-show="attribute.in_decision_tree"
			>
				<v-list-tile slot="activator" class="decision-tree__category">
					<v-list-tile-content>
						<v-list-tile-title>
							<span class="decision-tree__step-title">
								<span>Select {{ attribute.name }}</span>
								<span
									v-if="
										attribute.units &&
											attribute.name != 'Lifting Capacity'
									"
									>({{ attribute.units }})</span
								>
							</span>
							<span
								class="decision-tree__selection"
								v-if="
									selectedAttributes[attribute.slug] !==
										null &&
										selectedAttributes[attribute.slug] !==
											undefined
								"
							>
								{{
									convertValue(
										selectedAttributes[attribute.slug]
									)
								}}
								<span
									v-if="
										selectedAttributes[attribute.slug] ===
											'Hoist Carrier'
									"
									>Components</span
								>
								<span
									v-if="
										attribute.units &&
											attribute.name == 'Lifting Capacity'
									"
									v-text="
										parseFloat(
											selectedAttributes[attribute.slug]
										) > 1
											? attribute.units
											: attribute.units_singular
									"
									style="text-transform: capitalize;"
								></span>
							</span>
						</v-list-tile-title>
					</v-list-tile-content>

					<v-list-tile-action
						v-if="
							selectedAttributes[attribute.slug] !== null &&
								selectedAttributes[attribute.slug] !== undefined
						"
						@click.stop="resetAttribute(attribute.slug)"
					>
						<div class="v-icon">
							<fa-icon :icon="['fal', 'times']" size="xs" />
						</div>
					</v-list-tile-action>
				</v-list-tile>

				<v-list-tile
					v-for="value in attribute.values"
					:key="value"
					no-action
					class="decision-tree__value"
					v-show="!isAttributeDisabled(attribute.slug, value)"
					:class="{
						'decision-tree__value--disabled': isAttributeDisabled(
							attribute.slug,
							value
						)
					}"
					@click="selectAttribute(attribute.slug, value)"
				>
					<v-list-tile-content>
						<v-list-tile-title>
							<span>
								{{ convertValue(value) }}
								<span
									v-if="
										attribute.units &&
											attribute.name == 'Lifting Capacity'
									"
									v-text="
										parseFloat(value) > 1
											? attribute.units
											: attribute.units_singular
									"
									style="text-transform: capitalize;"
								></span>
							</span>
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list-group>
		</v-list>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	data() {
		return {
			currentAttribute: false,
			selectedAttributes: {}
		};
	},

	props: {
		category: {
			default: {}
		}
	},

	computed: {
		...mapGetters("products", [
			"categories",
			"attributes",
			"enabledAttributes"
		]),

		filteredAttributes() {
			if (this.attributes) {
				return this.attributes
					.map(attribute => {
						attribute = { ...attribute };

						if (this.category === "manual-hoist") {
							if (
								this.selectedAttributes.type ===
									"Lever Hoist" &&
								attribute.slug === "headroom"
							) {
								return false;
							}

							if (
								attribute.slug === "overload-device" &&
								attribute.values.length !== 2
							) {
								return false;
							}
						}

						if (this.category === "stock-wire-rope-hoist") {
							if (attribute.slug === "overload-device") {
								return false;
							}
						}

						if (this.category === "electric-chain-hoist") {
							if (attribute.slug === "suspension-type") {
								attribute.values = [
									"Hook Suspension",
									"Push/Pull Trolley",
									"Motorized Trolley"
								];
							}
						}

						if (this.category === "trolley") {
							if (attribute.name === "Sub Family") {
								attribute.values = [
									"Plain Trolley",
									"Geared Trolley",
									"Motorized Trolley"
								];
							}
						}

						return attribute;
					})
					.filter(v => v);
			}

			return [];
		}
	},

	methods: {
		...mapActions("products", {
			GET_ATTRIBUTES: "getAttributes",
			SEARCH_PRODUCTS: "searchProducts"
		}),

		filterProducts() {
			this.$emit("filter-products", this.selectedAttributes);
		},

		resetProducts() {
			this.$emit("reset-products");
		},

		selectAttribute(key, value) {
			if (!this.isAttributeDisabled(key, value)) {
				let newAttributes = { ...this.selectedAttributes };

				newAttributes[key] = value;

				this.$set(this, "selectedAttributes", newAttributes);

				// if(key !== 'type') {
				this.filterProducts();
				// }
			}
		},

		resetAttribute(key = false, filter = true) {
			Vue.delete(this.selectedAttributes, key);

			if (filter && key !== "type") {
				this.filterProducts();
			} else if (key === "type") {
				this.resetProducts();
			}

			this.getDecisionTree();
		},

		resetAllAttributes(resetSubFamily = true) {
			_.forEach(Object.keys(this.selectedAttributes), key => {
				if (!resetSubFamily && key === "type") {
					return true;
				}

				this.resetAttribute(key, false);
			});
		},

		getDecisionTree: _.debounce(function() {
			this.GET_ATTRIBUTES({
				category: this.category,
				params: this.selectedAttributes
			});
		}, 100),

		isAttributeDisabled(slug, value) {
			const attribute = _.find(this.enabledAttributes, { slug });

			return attribute.values.indexOf(value) === -1;
		},

		convertValue(value) {
			if (value === "true" || value === true) {
				return "Yes";
			} else if (value === "false" || value === false) {
				return "No";
			}

			return value;
		}
	},

	created() {
		this.getDecisionTree();
	},

	watch: {
		selectedAttributes: {
			handler(value, oldValue) {
				if (value.type !== oldValue.type) {
					this.resetAllAttributes(false);
				}

				this.getDecisionTree();
				this.currentAttribute = false;
			},
			deep: true
		}
	}
};
</script>
